export const CSR_CHAT_WINDOW_WIDTH = 348;
export const CSR_CHAT_WINDOW_GAP = 10;
export const CSR_CHAT_MINI_WIDTH = 220;
export const CSR_CHAT_MAX_OPEN = 6;
export const CSR_CHAT_DOCK_RIGHT = 16;

export function maxCsrExpandedChats() {
  if (typeof window === "undefined") return 3;
  if (window.innerWidth < 640) return 1;
  if (window.innerWidth < 1100) return 2;
  return 3;
}

/** Newest chats sit on the right, like Messenger. Minimized bars sit to the left. */
export function layoutCsrChatDock(openChats) {
  const expanded = [];
  const minimized = [];
  for (const item of openChats || []) {
    if (item.minimized) minimized.push(item);
    else expanded.push(item);
  }
  const laid = [];
  let right = CSR_CHAT_DOCK_RIGHT;
  for (let i = expanded.length - 1; i >= 0; i -= 1) {
    laid.push({
      ...expanded[i],
      offsetRight: right,
      dockZIndex: 46 + i,
    });
    right += CSR_CHAT_WINDOW_WIDTH + CSR_CHAT_WINDOW_GAP;
  }
  for (let i = minimized.length - 1; i >= 0; i -= 1) {
    laid.push({
      ...minimized[i],
      offsetRight: right,
      dockZIndex: 45,
    });
    right += CSR_CHAT_MINI_WIDTH + 8;
  }
  return laid;
}

export function upsertOpenCsrChat(prev, customer) {
  const uid = Number(customer?.userId);
  if (!Number.isFinite(uid) || uid <= 0) return prev || [];
  const maxExpanded = maxCsrExpandedChats();
  const idx = (prev || []).findIndex((x) => Number(x.customer?.userId) === uid);
  let next;
  if (idx >= 0) {
    const row = {
      ...prev[idx],
      customer: { ...prev[idx].customer, ...customer },
      minimized: false,
    };
    next = [...prev.filter((_, i) => i !== idx), row];
  } else {
    next = [...(prev || []), { customer, minimized: false }].slice(-CSR_CHAT_MAX_OPEN);
  }
  const expanded = next.filter((x) => !x.minimized);
  if (expanded.length <= maxExpanded) return next;
  const keep = new Set(
    expanded.slice(-maxExpanded).map((x) => Number(x.customer.userId))
  );
  return next.map((x) =>
    x.minimized || keep.has(Number(x.customer.userId)) ? x : { ...x, minimized: true }
  );
}
